'use strict';

angular.module('licensure.services')
    .factory('Saml', ['$http', '$q', '$stateParams', function ($http, $q, $stateParams) {
        return {
            idpSignIn: function (isPortal, entityId) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/Saml20/SignIn?isPortal=" + isPortal + "&idp=" + entityId, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        if (!$stateParams.messages) {
                            $stateParams.messages = [];
                        }
                        $stateParams.messages[0] = "There was an unexpected issue with the sign-in process. Please try again later.";
                        d.resolve(null);
                    })
                return d.promise;
            },
            idpSignOut: function (returnUrl) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/Saml20/Logout?redirect=false&ReturnUrl=" + encodeURIComponent(returnUrl), {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },
        }
    }])
;